// extracted by mini-css-extract-plugin
export default {"imageWrapper":"FJ-z","twoColumnImage":"GJ-z"};